import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const Footer = () => {
  const solutions = [{
    name: 'Restaurants',
    url: 'https://restaurant.smartsoda.com',
    description: 'Sustainable beverage solutions'
  }, {
    name: 'Breakrooms',
    url: 'https://breakrooms.smartsoda.com',
    description: 'Transform your workplace beverage experience'
  }, {
    name: 'Showrooms',
    url: 'https://showroom.smartsoda.com',
    description: 'Elevate customer engagement'
  }, {
    name: 'Spas & Wellness',
    url: 'https://spa.smartsoda.com',
    description: 'Premium hydration for wellness centers'
  }];
  return <footer className="bg-gradient-to-br from-navy-950 via-navy-950 to-blue-950 text-white relative overflow-hidden" data-id="element-240">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-241">
        <div className="absolute -top-20 -right-20 w-96 h-96 bg-blue-500 rounded-full opacity-5 blur-3xl" data-id="element-242"></div>
        <div className="absolute bottom-0 -left-20 w-80 h-80 bg-blue-400 rounded-full opacity-5 blur-3xl" data-id="element-243"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10" data-id="element-244">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-245">
          {/* Brand Section */}
          <div className="lg:col-span-1" data-id="element-246">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jq92PGrktbCMyEbrUBGpE9/SS-Logomark_Ether.webp" alt="SmartSoda Badge Logo" className="h-16 mb-6" width="64" height="64" loading="lazy" decoding="async" data-id="element-247" />
            <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-248">
              Premium beverage solutions that elevate experiences and support
              sustainability.
            </p>
            <div className="flex space-x-4" data-id="element-249">
              <a href="https://www.linkedin.com/company/smart-soda" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors" aria-label="LinkedIn" data-id="element-250">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-251">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" data-id="element-252" />
                </svg>
              </a>
              <a href="https://www.instagram.com/drinksmartsoda/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors" aria-label="Instagram" data-id="element-253">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-254">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" data-id="element-255" />
                </svg>
              </a>
            </div>
          </div>
          {/* Solutions Section */}
          <div className="lg:col-span-2" data-id="element-256">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-257">
              Our Solutions
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-258">
              {solutions.map((solution, index) => <a key={index} href={solution.url} target="_blank" rel="noopener noreferrer" className="group bg-white/5 backdrop-blur-sm rounded-lg p-4 hover:bg-white/10 transition-all duration-300 border border-white/10 hover:border-blue-400/50" data-id="element-259">
                  <div className="flex items-start justify-between" data-id="element-260">
                    <div className="flex-1" data-id="element-261">
                      <h4 className="font-semibold text-white group-hover:text-blue-400 transition-colors mb-1" data-id="element-262">
                        {solution.name}
                      </h4>
                      <p className="text-xs text-gray-400 leading-relaxed" data-id="element-263">
                        {solution.description}
                      </p>
                    </div>
                    <ArrowRightIcon className="h-4 w-4 text-gray-400 group-hover:text-blue-400 group-hover:translate-x-1 transition-all flex-shrink-0 ml-2 mt-1" data-id="element-264" />
                  </div>
                </a>)}
            </div>
          </div>
          {/* Contact Section */}
          <div className="lg:col-span-1" data-id="element-265">
            <h3 className="text-lg font-semibold mb-6 text-white" data-id="element-266">
              Get in Touch
            </h3>
            <ul className="space-y-4" data-id="element-267">
              <li data-id="element-268">
                <a href="mailto:office@smartsoda.com" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center group" data-id="element-269">
                  <svg className="h-5 w-5 mr-3 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-270">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-271" />
                  </svg>
                  <span className="text-sm" data-id="element-272">office@smartsoda.com</span>
                </a>
              </li>
              <li className="pt-4" data-id="element-273">
                <a href="#book-demo" className="inline-flex items-center justify-center px-6 py-3 border border-blue-400 text-sm font-medium rounded-lg text-white bg-blue-500/20 hover:bg-blue-500 backdrop-blur-sm transition-all duration-300 group" data-id="element-274">
                  Book a Demo
                  <ArrowRightIcon className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" data-id="element-275" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10" data-id="element-276">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-277">
            <p className="text-sm text-gray-400 text-center md:text-left" data-id="element-278">
              &copy; {new Date().getFullYear()} SmartSoda, Inc. All rights
              reserved.
            </p>
            <p className="text-xs text-gray-500 text-center md:text-right max-w-md" data-id="element-279">
              SmartSoda is committed to creating delicious beverages with
              sustainable practices.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;